import React, { useEffect, useState } from "react";
import TextField from "../Partial/TextField";
import Button from "../Partial/Button";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { loginApiCall } from "../../store/actions/projectAction";
import { Link, useNavigate } from "react-router-dom";
import { ROTUES } from "../../utils/global";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  getAuth,
  PhoneAuthProvider,
  RecaptchaVerifier,
  signInWithCredential,
  signInWithPhoneNumber,
} from "firebase/auth";
import { toast } from "react-toastify";
import OtpEnterScreen from "./OtpVarifier";
import { setLoading } from "../../store/reducer/projectSlice";

function Login() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [confirmationResult, setConfirmationResult] = useState(null);
  const navigate = useNavigate();

  const auth = getAuth();
  auth.useDeviceLanguage();

  const generateRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "invisible",
        callback: () => {
          dispatch(
            setLoading({
              code: "firebase_login",
              loading: true,
            })
          );
        },
        "expired-callback": () => {
          window.recaptchaVerifier.render().then(function (widgetId) {
            window.grecaptcha.reset(widgetId); // Reset CAPTCHA on expiration
          });
        },
      }
    );

    window.recaptchaVerifier.render();
  };

  const handleLogin = async (data) => {
    const phoneNumber = data?.phone;
    const appVerifier = window.recaptchaVerifier;
    const formattedPhoneNumber = phoneNumber.startsWith("+")
      ? phoneNumber
      : `+${phoneNumber}`;

    signInWithPhoneNumber(auth, formattedPhoneNumber, appVerifier)
      .then((result) => {
        dispatch(
          setLoading({
            code: "firebase_login",
            loading: false,
          })
        );

        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        setConfirmationResult(result);
        window.confirmationResult = result;
        toast.success("Otp is sent to your mobile number");
        window.localStorage.setItem("loginInfo", JSON.stringify(data));
      })
      .catch((error) => {
        console.log(error)
        const errorCode = error.code;
        if (errorCode == "auth/billing-not-enabled") {
          toast.error("Please try again service is not available");
        }
        dispatch(
          setLoading({
            code: "firebase_login",
            loading: false,
          })
        );

        window.recaptchaVerifier.render().then(function (widgetId) {
          window.grecaptcha.reset(widgetId);
        });

        // window?.grecaptcha.reset(window.recaptchaWidgetId);
      });
  };

  const handleOnOtpVarify = async (otp, data) => {
    const enteredOtp = otp.join(""); // Join the OTP array into a string

    const loginInfoJson = window.localStorage.getItem("loginInfo");
    const loginInfo = loginInfoJson ? JSON.parse(loginInfoJson) : null;

    if (!window?.confirmationResult || !loginInfo) {
      return;
    }
    try {
      dispatch(
        setLoading({
          code: "firebase_login_varify",
          loading: true,
        })
      );

      var credential = await PhoneAuthProvider.credential(
        window.confirmationResult.verificationId,
        enteredOtp
      );

      const auth = getAuth();

      const userCredential = await signInWithCredential(auth, credential);
      const user = userCredential.user;

      const token = await user.getIdToken();
      dispatch(
        setLoading({
          code: "firebase_login_varify",
          loading: false,
        })
      );
      await dispatch(
        loginApiCall({
          ...loginInfo,
          role: "user",
          token,
        })
      );
    } catch (error) {
      dispatch(
        setLoading({
          code: "firebase_login_varify",
          loading: false,
        })
      );
      const errorCode = error.code;
      if (errorCode == "auth/invalid-verification-code") {
        toast.error("Invalid varification code");
      }
    }
  };

  useEffect(() => {
    generateRecaptcha();
  }, []);

  return (
    <div className="w-full flex">
      <div className="w-[50%] h-screen bg-[#00428C]"></div>
      <div className="w-[50%] h-[100vh] flex flex-col justify-center items-center">
        <div className="w-[100%] md:w-[50%] lg:w-[50%] flex gap-[15px] flex-col justify-center items-center px-2 md:px-0 lg:px-0">
          <div className="flex">
            <div className="w-[200px] h-[180px]  rounded-md flex justify-center items-center">
              <img src="/Logo_Transaprent.png" alt="logo" className="w-full h-full" />
            </div>
          </div>

          {!confirmationResult && (
            <form
              className="w-full flex flex-col gap-[16px]"
              onSubmit={handleSubmit(handleLogin)}
            >
              <div className="flex w-full h-full flex-col gap-[10px]">
                <div>
                  <PhoneInput
                    country={"in"}
                    enableSearch
                    placeholder="Enter your phone"
                    inputStyle={{ width: "100%" }}
                    onChange={(value) => setValue("phone", value)} // Validate on change
                  />
                  <input
                    type="hidden"
                    {...register("phone", {
                      required: "Phone number is required",
                      validate: (value) => {
                        const phoneWithoutCode = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                        return (
                          phoneWithoutCode.length - 2 === 10 ||
                          "Phone number must be exactly 10 digits"
                        );
                      },
                    })}
                  />
                  {errors.phone && (
                    <p className="text-red-400 text-left ml-1 text-sm">
                      {errors.phone.message}
                    </p>
                  )}
                </div>
                <div className="flex justify-end">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      window.location.href = ROTUES.register;
                    }}
                  >
                    Create Account
                  </div>
                </div>
              </div>

              <Button
                type="submit"
                text="Login"
                className="w-full"
                // isLoading={isLoading}
              />
            </form>
          )}

          <div id="recaptcha-container"></div>

          {confirmationResult && (
            <OtpEnterScreen onOtpVarifyCallback={handleOnOtpVarify} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
